export const instantDbAppId = "64b555f6-1fcd-4033-ac96-670fc77543a9";
export const agentFomoDomain = "f0mo.com";
export const apiUrlPath = "/api";
export const agentFomoPhone = "972504244206";
export const groupBotPhone = "972507102788";
export const nitzanEmail = "nizzanav@gmail.com";
export const uriEmail = "uri.valevski@gmail.com";
export const adminEmails = [nitzanEmail, uriEmail];
export const developersFeedbackLink =
  "https://chat.whatsapp.com/G8h77OtbLQCLPH9BlKpwzW";
export const webAppUrl = "https://hi." + agentFomoDomain;
export const termsAndConditionsLink = `${webAppUrl}/terms`;
export const stripeProductId = "prod_UGfDpPPwBGRJHa";
export const promotionCreditsPerPack = 50;
export const promotionCreditsCostCents = 5000;
export const viewChatGroupId = "5b1a8908-2628-4bff-8ea1-09453cdf79d0";
// view-chat stores conversations under autobotbuilder/<botId>/<conversationId>
// and the conversations page matches conversationName with an $ilike suffix
// query, so the raw conversation id is enough to locate the thread.
export const viewChatConversationLink = (
  conversationId?: string | null,
  messageId?: string | null,
) =>
  conversationId && conversationId !== "current"
    ? `https://view-chat.com/conversations?groupId=${viewChatGroupId}&conversationName=${
      encodeURIComponent(conversationId)
    }${messageId ? `#${encodeURIComponent(messageId)}` : ""}`
    : null;
